import React, { useState, useEffect } from "react";
import { HeaderConfig } from "./config";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PAGE_LIMIT } from "../../../utils";
import DeleteModal from "../../../components/delete-modal";
import CustomButtonComponent from "../../../core/custom-button";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import CreateActualPlan from "./create-actual-plan";
import ActualFilters from "./actual-filters";

const LisTrainingVsActual = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [editData, setEditData] = useState({});
  const [mainFilters, setMainFilters] = useState({});
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const ClickHandler = (type, data) => {
    switch (type) {
      case "EDIT":
        setIsCreate(true);
        setEditData(data);
        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  const deleteHandler = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.TRAINING_TOUCH_POINTS}/${isDelete?.data?.id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
          setIsDelete({ isOpen: false, data: {} });
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.TRAINING_TOUCH_POINTS}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (data?.totalPages !== 0 && data?.totalPages < data?.page) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [data]);
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        {isCreate && (
          <IconButton
            onClick={() => {
              setIsCreate(false);
              setEditData({});
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <div className="create-con" style={{ width: "100%" }}>
          <div>
            <p className="tab-name">Training</p>
            <p className="section-name">Training plan vs Actual</p>
          </div>
          {!isCreate && (
            <CustomButtonComponent
              variant="contained"
              color="primary"
              onClick={() => {
                setEditData({});
                setIsCreate(true);
              }}
            >
              Create Training Touch Point
            </CustomButtonComponent>
          )}
        </div>
      </div>

      {isCreate ? (
        <CreateActualPlan
          loadData={loadData}
          setIsCreate={setIsCreate}
          editData={editData}
        />
      ) : (
        <div>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={data.results || []}
              pageCount={data.totalPages}
              filters={filters}
              onClick={ClickHandler}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  ...mainFilters,
                  page,
                });
              }}
              isLoading={isLoading}
              filterCom={
                <ActualFilters
                  loadData={loadData}
                  setMainFilters={setMainFilters}
                  filter={filters}
                />
              }
            />
          </div>
        </div>
      )}
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
    </div>
  );
};
export default LisTrainingVsActual;
